import {
  ADD_CONFIGURATOR_SELECTION,
  REMOVE_CONFIGURATOR_SELECTION,
  SET_CONFIGURATOR_SELECTION,
  TOGGLE_CONFIGURATOR_SELECTION,
  UPDATE_PAGE_CONTENT
} from "shared/constants/appConstants";

export default class ConfiguratorActions {
  constructor(dispatch, url) {
    this.dispatch = dispatch;
    this.url = url;
  }

  getMapping() {
    return fetch(`${this.url}/mapping`)
      .then(response => response.json())
      .then(json => {
        this.dispatch({
          type: UPDATE_PAGE_CONTENT,
          payload: { configuratorImageMapping: json }
        });
      });
  }

  addPreviewOption = (subLineItemId, optionId) => {
    this.dispatch({
      type: ADD_CONFIGURATOR_SELECTION,
      payload: { subLineItemId, optionId }
    });
  };

  removePreviewOption = (subLineItemId, optionId) => {
    this.dispatch({
      type: REMOVE_CONFIGURATOR_SELECTION,
      payload: { subLineItemId, optionId }
    });
  };

  togglePreviewOption = (subLineItemId, optionId) => {
    this.dispatch({
      type: TOGGLE_CONFIGURATOR_SELECTION,
      payload: { subLineItemId, optionId }
    });
  };

  setPreviewOption = (subLineItemId, optionId) => {
    this.dispatch({
      type: SET_CONFIGURATOR_SELECTION,
      payload: { subLineItemId, optionId }
    });
  };
}
